var PopupLayout   = require("app/AppLayout/PopupLayout"),
    dom           = require("enyo/dom"),
    kind          = require("enyo/kind"),
    quickMacroize = require("enyo/macroize").quickMacroize,
    themeVars     = require("app/theme/variables.js");

module.exports = kind(/** @lends  app.AppLayout.PopupLayout.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.PopupLayout",

    /**
     * @private
     */
    kind: PopupLayout,

    /**
     * @public
     */
    reflow: kind.inherit(function(sup) {
        return function() {
            var container    = this.container,
                appView      = container.app.view,
                $content     = container.$.content,
                contentNode  = $content.hasNode(),
                $buttonBar   = container.$.buttonBar,
                $firstButton = $buttonBar.children[0],
                contentMaxWidth,
                contentLeftPadding,
                contentRightPadding,
                contentMaxInnerWidth,
                buttonWidth,
                gapWidth,
                buttonBarColCount;

            if (!appView.hasNode() || !container.hasNode() || !contentNode) {
                return;
            }

            sup.apply(this, arguments);

            contentMaxWidth      = parseFloat(dom.getComputedStyleValue(contentNode, "max-width"), 10);
            contentLeftPadding   = parseFloat(dom.getComputedStyleValue(contentNode, "padding-left"), 10);
            contentRightPadding  = parseFloat(dom.getComputedStyleValue(contentNode, "padding-right"), 10);
            contentMaxInnerWidth = contentMaxWidth - contentLeftPadding - contentRightPadding;
            buttonWidth          = $firstButton.getBounds().width;
            gapWidth             = themeVars.getContentPaddingHorizontalPx();

            buttonBarColCount = Math.min(
                $buttonBar.children.length,
                Math.floor((contentMaxInnerWidth + gapWidth) / (buttonWidth + gapWidth))
            );
            $buttonBar.addStyles({
                "grid-template-columns": quickMacroize("repeat({$buttonBarColCount}, {$gapWidth}px)", {
                    buttonBarColCount: buttonBarColCount,
                    gapWidth:          buttonWidth
                }),
                "grid-column-gap": gapWidth + "px"
            });
        };
    })
});
